import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "wbo-ok-button",
    styleUrls: ["./ok-button.component.scss"],
    templateUrl: "ok-button.component.html"
})
export class OkButtonComponent {
    @Input() @HostBinding("class.disabled") disabled: boolean;
    @Input() public title: string;
}
